var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayCarrier)?_c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":`/static/images/carrier/${_vm.displayCarrier}`,"height":_vm.imgHeight,"width":_vm.imgWidth}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }